import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

import ImgA from "../../assets/images/startup.jpg";
import WaitlistForm from "../../component/WaitlistForm";

class Section extends Component {
  constructor() {
    super();
    const selectedExperiment = [
      {
        waitlist_version: 1,
        waitlist_name: "smallties",
        header: "Launch with Confidence -- Validate Your Idea Before You Build",
        subheader:
          "Save months of wasted time and resources by testing demand for your idea. Build your first 100 customers and launch to a crowd—not crickets. No guesswork—just proof that your idea is in demand. ",
        CTA: "Create a page to validate my business idea.",
        img: ImgA,
      },
    ];

    this.state = {
      isOpen: false,
      selectedExperiment,
    };

    this.openModal = this.openModal.bind(this);
  }

  openModal() {
    this.setState({ isOpen: true });
  }

  render() {
    const { header, subheader, img } = this.state.selectedExperiment;

    return (
      <React.Fragment>
        <section className="bg-home bg-light" id="home">
          <div className="home-center">
            <div className="home-desc-center">
              <Container>
                <Row className="align-items-center">
                  <Col lg={6}>
                    <div className="home-content">
                      <div className="home-img">
                        <div className="animation-4"></div>
                      </div>
                      <p className="biz-name mt-4 mb-0">SMALL TIES</p>
                      <h1 className="home-title mt-4">
                        Launch with Confidence - Validate Your Idea{" "}
                        <em>Before</em> You Build
                      </h1>
                      <p className="text-muted mt-4 f-20">
                        Save months of wasted time and resources by testing
                        demand for your idea. Build your first 100 customers and
                        launch to a crowd—not crickets. No guesswork—just proof
                        that your idea is in demand. Let's get started with your
                        name and email.
                      </p>
                      <WaitlistForm
                        selectedExperiment={this.state.selectedExperiment[0]}
                      />
                      <p className="text-muted mt-4 f-10 text-center">
                        We'll never share your information with anyone.
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="home-img">
                      <div className="animation-1"></div>
                      <div className="animation-2"></div>
                      <div className="animation-3"></div>
                      <div className="hero">
                        <img
                          src={ImgA}
                          className="img-fluid hero-photo"
                          alt=""
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
